import { LitElement, html } from "lit-element";

export class DdlInput extends LitElement {
	shouldUpdate() {
		return this.options != undefined;
	}

	render() {
		const hasValue = this._hasValue(this.value);

		return html`
		<style>
			:host {
				display: block;
			}

			.group {
                margin-bottom: 10px;

				padding-top: 16px;
				position: relative;
				background-color: var(--primary-color-variant3);
				border-radius: 3px 3px 0px 0px;
			}

			option {
				background-color: var(--primary-color-variant3);
			}

			select {
				background: none;
				color: var(--secondary-color-variant1);
				font-size: 18px;
				padding: 10px 10px 10px 5px;
				display: block;
				width: 100%;
				border: none;
				border-radius: 0;
				border-bottom: 1px solid var(--secondary-color);
			}

			select:focus {
				outline: none;
			}

			select:focus~label,
			select[has-value]~label {
				top: 4px;
				font-size: 12px;
				color: var(--secondary-color-variant1);
			}

			select:focus~.bar:before {
				width: 100%;
			}

			label {
				color: #c6c6c6;
				font-size: 16px;
				font-weight: normal;
				position: absolute;
				pointer-events: none;
				left: 5px;
				top: 8px;
				transition: 300ms ease all;
				width: 99%;
				padding: 1px;
				-webkit-line-clamp: 2;
				text-overflow: ellipsis;
				overflow: hidden;
				max-height: 50px;
			}

			.group:focus~label,
			.group:focus~label,
			.group[has-value]~label,
			.group[has-value]~label {
				width: 99%;
				white-space: nowrap;
			}

			.bar {
				position: relative;
				display: block;
				width: auto;
			}

			.bar:before {
				content: '';
				height: 2px;
				width: 0;
				bottom: 0px;
				position: absolute;
				background: var(--secondary-color);

				transition: 300ms ease all;
				left: 0%;
			}

			.group > .helper-text {
				visibility: hidden;
				position: absolute;
				left: 5px;
				bottom: -16px;
				margin: 0;
				padding: 0;
				color: rgba(0, 0, 0, 0.6);
				font-size: 0.75rem;
				background-color: white;
				height: calc(1em + 4px);
				overflow: hidden;
				text-overflow: ellipsis;
				word-break: break-all;
				white-space: nowrap;
				width: 100%;
			}

			.group > .helper-text[isVisible] {
				visibility: visible;
			}

			select[invalid]~.helper-text,
			select[invalid]~label {
				color: red;
			}

			select[invalid] {
				border-bottom: 1px solid red;
			}

			select[invalid]~.bar:before {
				background: red;
			}
		</style>
		<div class="group">
			<select ?disabled="${this.disabled}" id="select"
				@change="${(e) => this.handleChange(e)}" 
				@blur="${(e) => this.handleBlur(e)}" 
				?has-value="${hasValue}"
				?required="${this.required}"
				?invalid="${this.isInvalid}">
				<option></option>
				${this.options.map(o => html`<option value="${o.val || o.value}">${o.text}</option>`)}
			</select>
			<span class="highlight"></span>
			<span class="bar"></span>
			<label>${this.label + (this.required == true ? "*" : "")}</label>
			<p class="helper-text" ?isVisible="${this.isHelperTextVisible()}">
				${this.getHelperText()}
			</p>
		</div>`;
	}

	isHelperTextVisible() {
		return (this.isInvalid || this.helperText);
	}

	getHelperText() {
		return this.isInvalid ? (this.validationMessage || this._getDefaultMessage()) : this.helperText;
	}

	_getDefaultMessage() {
		return "The '" + this.label + "' is invalid!";
	}

	_hasValue(value) {
		return (value !== undefined && value !== null && value !== "");
	}

	updated() {
		const hasValue = this._hasValue(this.value);
		const select = this.shadowRoot.getElementById("select");
		if (!hasValue) {
			select.selectedIndex = 0;
		} else {
			const idx = this.options.findIndex(i => i.val == this.value || i.value == this.value);
			select.selectedIndex = idx + 1;
		}
	}

	_dispatchEvent(name, detail) {
		this.dispatchEvent(
			new CustomEvent(name, {
				detail: detail,
				composed: true
			})
		);
	}

	handleChange(e) {
		if (this.disabled) return;
		this._wasChangeEvent = true;
		this.value = e.target.value === "" ? undefined : e.target.value;

		this._dispatchEvent("inspx-change", { target: this, value: this.value, path: this.path });
	}

	handleBlur(e) {
		if (!this.path) return;
		if (this._wasChangeEvent) {
			this._wasChangeEvent = false;
			return;
		}

		this._dispatchEvent("inspx-input-blur", { target: this, path: this.path });
	}

	static get properties() {
		return {
			value: String,
			type: String,
			label: String,
			required: { type: Boolean },
			disabled: { type: Boolean },
			options: Array,
			path: String,
			isInvalid: { type: Boolean },
			validationMessage: { type: String },
			helperText: { type: String },
		};
	}
}
window.customElements.define("ddl-input", DdlInput);
